import { render, staticRenderFns } from "./MediumCourseTeaser.vue?vue&type=template&id=da8ac7e4&scoped=true&"
import script from "./MediumCourseTeaser.vue?vue&type=script&lang=js&"
export * from "./MediumCourseTeaser.vue?vue&type=script&lang=js&"
import style0 from "./MediumCourseTeaser.vue?vue&type=style&index=0&id=da8ac7e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8ac7e4",
  null
  
)

export default component.exports